export const stepperGiftInfo = {
  currentStep: {
    title: "Gift Information",
  },
  nextSteps: [
    {
      title: "Confirmation",
    },
    {
      title: "Payment",
    },
  ],
};

export const stepperGift = {
  currentStep: {
    title: "Gift",
  },
  nextSteps: [
    {
      title: "Details",
    },
    {
      title: "Payment",
    },
  ],
};

export const stepperConfirmation = {
  doneSteps: [
    {
      title: "Gift Information",
    },
  ],
  currentStep: {
    title: "Confirmation",
  },
  nextSteps: [
    {
      title: "Payment",
    },
  ],
};

export const stepperDetails = {
  doneSteps: [
    {
      title: "Gift",
    },
  ],
  currentStep: {
    title: "Details",
  },
  nextSteps: [
    {
      title: "Payment",
    },
  ],
};

export const stepperPayment = {
  doneSteps: [
    {
      title: "Gift Information",
    },
    {
      title: "Confirmation",
    },
  ],
  currentStep: {
    title: "Payment",
  },
};

export const stepperPay = {
  doneSteps: [
    {
      title: "Gift",
    },
    {
      title: "Details",
    },
  ],
  currentStep: {
    title: "Payment",
  },
};

export const stepperCampaignRegistration = {
  currentStep: {
    title: "Registration",
  },
  nextSteps: [
    {
      title: "Media Upload",
    },
    {
      title: "Confirm Campaign",
    },
  ],
};

export const stepperCampaignMediaUpload = {
  doneSteps: [
    {
      title: "Registration",
    },
  ],
  currentStep: {
    title: "Media Upload",
  },
  nextSteps: [
    {
      title: "Confirm Campaign",
    },
  ],
};

export const stepperCampaignConfirmation = {
  doneSteps: [
    {
      title: "Registration",
    },
    {
      title: "Media Upload",
    },
  ],
  currentStep: {
    title: "Confirm Campaign",
  },
};
